let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g7vuZ")).then(() => parcelRequire('j9knx'));